import React, { useCallback } from 'react';
import classNames from 'classnames';
import styles from './CategoryToggle.module.scss';

const CategoryToggle = ({ value, onChange, options = [] }) => {
  const handleSelect = useCallback(
    nextValue => {
      if (nextValue === value) return;
      onChange(nextValue);
    },
    [value, onChange],
  );

  return (
    <div className={styles['category-toggle']} role="tablist">
      {options.map(option => {
        const isActive = option.value === value;
        return (
          <button
            key={option.value}
            type="button"
            role="tab"
            aria-selected={isActive}
            className={classNames(styles['category-toggle__pill'], {
              [styles['category-toggle__pill--active']]: isActive,
            })}
            onClick={() => handleSelect(option.value)}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
};

export default CategoryToggle;
